// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase:  {
    apiKey: "AIzaSyCtALzfmPOga61H8RoY2fHkjSNpa-fNt6g",
    authDomain: "covidfreeworkforce.firebaseapp.com",
    databaseURL: "https://covidfreeworkforce.firebaseio.com",
    projectId: "covidfreeworkforce",
    storageBucket: "covidfreeworkforce.appspot.com",
    messagingSenderId: "258001162905",
    appId: "1:258001162905:web:0d1563eaaeef200054de08",
    measurementId: "G-085Y2QZG79"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
 import 'zone.js/dist/zone-error';  // Included with Angular CLI.
